// To add a new kitten:
//
// 1. Add SVG component in this folder.
// 	- Add .fill to all body elements.
// 	- Add .fill--face to all face elements (blinking eyes and nose, NOT open eyes).
// 	- Add .fill--eyes to open eyes (NOT blinking eyes).
// 	- Add <g> .kitten-eyes around open eyes.
// 	- Add <g> .kitten-eyes--blink around blinking eyes.
// 2. Import the component here.
// 3. Add it to `kittenOptions` here.
// 4. Add a new story in `src/stories/kittens.js`
// 5. Add goody rules to `utils/getKitten.js`
// 6. Add styles to `scss/pet/kittens/_[kitten-name].scss`

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import PetHOC from '../../PetHOC';
import Frisky from './Frisky';
import Bonsai from './Bonsai';
import Camper from './Camper';
import Fan from './Fan';
import Midi from './Midi';
import Rocketship from './Rocketship';
import Scuba from './Scuba';
import Unicorn from './Unicorn';
import Athlete from './Athlete';
import Coffee from './Coffee';
import Chef from './Chef';
import Birthday from './Birthday';

const kittenOptions = {
	Frisky,
	Bonsai,
	Camper,
	Fan,
	Midi,
	Rocketship,
	Scuba,
	Unicorn,
	Athlete,
	Coffee,
	Chef,
	Birthday,
};

class Kitten extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			universalActions: {},
			actions: {
				idle: {},
			},
		};

		this.staticClasses = ['pet', 'fill--kitten', this.props.kitten];

		this.actions = {
			idle: [
				{
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: () => _.random(200, 3000),
					},
					stop: {
						timeout: null,
						interval: () => 199,
					},
				},
			],
		};

		this.loopAllActions = PetHOC.prototype.loopAllActions.bind(this);
		this.setAction = PetHOC.prototype.setAction.bind(this);
		this.loopAction = PetHOC.prototype.loopAction.bind(this);
		this.stopActions = PetHOC.prototype.stopActions.bind(this);
		this.getClassNames = PetHOC.prototype.getClassNames.bind(this);
	}

	componentDidMount() {
		this.loopAllActions('idle');
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.kitten !== nextProps.kitten) {
			this.staticClasses = ['pet', 'fill--kitten', nextProps.kitten];
		}
	}

	componentWillUnmount() {
		this.stopActions('idle');
	}

	render() {
		const ThisKitten = kittenOptions[this.props.kitten];

		if (!this.props.kitten || !ThisKitten) {
			return null;
		}

		return (
			<div className="pet-kitten">
				<svg className={this.getClassNames()} version="1.1" viewBox="0 0 740 480" x="0px" y="0px" xmlSpace="preserve">
					<ThisKitten />
				</svg>
			</div>
		);
	}
}

Kitten.propTypes = {
	kitten: PropTypes.string,
};

Kitten.defaultProps = {
	kitten: '',
};

export default Kitten;



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Cat/Kitten/_Kitten.js